import styled from 'styled-components'

export const StyledNewsSaveSearch = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
`
